Ext.define('SA.view.Position', {
    statics: {
        create({top, left}) {
            return new SA.view.Position({top, left});
        },

        forEl(el) {
            return this.create(el.getBoundingClientRect());
        },

        fromMouseEvent({clientY: top, clientX: left}) {
            return this.create({top, left});
        }
    },

    constructor({top, left}) {
        this.top = top;
        this.left = left;
    },

    getLeft() {
        return this.left;
    },

    getTop() {
        return this.top;
    },

    subtract(otherPosition) {
        var top = this.getTop() - otherPosition.getTop(),
            left = this.getLeft() - otherPosition.getLeft();

        return SA.view.Position.create({top, left});
    }
});